import React, { useEffect, useState } from "react";
import { notify } from "./Toast/Toast";

export const EditView = ({ object, id, type, refresh }) => {
  const [itemGroups, setItemGroups] = useState([
    { ID: object.ItemGroupID, Name: object.ItemGroup },
  ]);
  const [subItemGroups, setSubItemGroups] = useState([
    {
      ID: object.ItemSubGroupID,
      Name: object.ItemSubGroup,
      ItemGroupID: object.ItemGroupID,
    },
  ]);

  const getInitialState = () => {
    let baseState = {
      type: type, // Using the 'type' prop passed to the component
    };

    switch (type) {
      case "Product":
        return {
          ...baseState, // Spread the baseState to include 'type'
          ID: object.ID || 0,
          Name: object.Name || "",
          EAN1: object.EAN1 || "",
          EAN2: object.EAN2 || "",
          EAN3: object.EAN3 || "",
          Price: object.Price || "",
          Volume: object.Volume || "",
          ItemGroupID: object.ItemGroupID || "",
          ItemSubGroupID: object.ItemSubGroupID || "",
        };
      case "InventoryData":
        return {
          ...baseState, // Spread the baseState to include 'type'
          Name: object.Name || "",
          Price: object.Price || "",
          Volume: object.Volume || "",
          ItemGroupID: object.ItemGroupID || "",
          ItemSubGroupID: object.ItemSubGroupID || "",
          Amount: object.Amount || 0,
          ProductID: object.ID || "",
          InventoryID: id || "",
          BarID: object.BarID || 0,
        };
      case "Bar":
        return {
          ...baseState,
          Name: object.name || "",
          ID: object.ID || 0,
        };
      case "User":
        return {
          ...baseState,
          ID: object.id,
          Admin: object.admin,
        };
      default:
        return baseState; // Return baseState for the default case
    }
  };

  const [formData, setFormData] = useState(getInitialState());
  useEffect(() => {
    // Fetch item groups
    fetch(
      "https://inventy.redata.se/inventdb/api-itemGroups.php?Command=Select",
    )
      .then((response) => response.json())
      .then((data) => setItemGroups(data))
      .catch((error) => {
        notify("error", "Kunde inte hämta produktgrupper");
        console.log(error);
      });

    // Fetch sub item groups
    fetch(
      "https://inventy.redata.se/inventdb/api-itemSubGroup.php?Command=Select",
    )
      .then((response) => response.json())
      .then((data) => setSubItemGroups(data))
      .catch((error) => {
        notify("error", "Kunde inte hämta subgrupper");
        console.log(error);
      });
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  function handleDelete() {
    if (!id) {
      notify("error", "ID saknas. Kunde inte radera.");
      return;
    }

    switch (type) {
      case "InventoryData":
        deleteCountData(id);
        break;
      case "Product":
        deleteProduct(id);
        break;
      case "Bar":
        deleteBar(id);
        break;
      default:
        notify("error", "Ogiltig typ för radering.");
    }
  }

  function deleteBar(id) {
    fetch("https://inventy.redata.se/inventdb/api_deleteBar.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ID: id }),
    })
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Bar borttagen");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte radera bar.");
      });
  }

  function deleteProduct(id) {
    fetch("https://inventy.redata.se/inventdb/api_deleteProduct.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ID: id }),
    })
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Produkt borttagen");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte radera produkt.");
      });
  }

  function updateProduct() {
    if (!formData.Name || !formData.Price) {
      notify("error", "Namn och pris måste anges.");
      return;
    }

    fetch("https://inventy.redata.se/inventdb/api_updateProduct.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Produkt sparad");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte spara produkt.");
      });
  }

  function deleteCountData(id) {
    fetch("https://inventy.redata.se/inventdb/api_deleteCountData.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ InventoryID: id, ProductID: object.ID }),
    })
      .then(() => {
        notify("success", "Produkt borttagen");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte radera inventeringsdata.");
      });
  }

  function updateCount() {
    if (!formData.Amount || formData.Amount <= 0) {
      notify("error", "Mängden måste vara större än noll.");
      return Promise.reject("Mängden måste vara större än noll.");
    }

    return fetch(
      "https://inventy.redata.se/inventdb/api_updateInventoryData.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      },
    )
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Rad sparad");
        return data;
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte uppdatera inventeringsdata.");
        throw error;
      });
  }

  function updateBar() {
    if (!formData.Name) {
      notify("error", "Namn måste anges.");
      return;
    }

    fetch("https://inventy.redata.se/inventdb/api_updateBar.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Bar sparad");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte spara bar.");
      });
  }

  function updateUser() {
    if (formData.Admin === undefined) {
      notify("error", "Admin-status måste anges.");
      return;
    }

    fetch("https://inventy.redata.se/inventdb/api_updateUser.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        notify("success", "Användare sparad");
        refresh();
      })
      .catch((error) => {
        console.error("Error:", error);
        notify("error", "Kunde inte spara användare.");
      });
  }

  function handleSave() {
    switch (type) {
      case "Product":
        updateProduct();
        break;
      case "InventoryData":
        updateCount().then(() => {
          refresh();
        });
        break;
      case "Bar":
        updateBar();
        break;
      case "User":
        updateUser();
        break;
      default:
        notify("error", "Ogiltig typ för sparning.");
    }
  }

  const renderProductView = () => (
    <>
      <td>
        <input
          type="text"
          name="Name"
          id="Name"
          value={formData.Name}
          onChange={handleInputChange}
        />
      </td>
      <td>
        {[1, 2, 3].map((i) => {
          const s = `EAN${i}`;
          return (
            <div key={s}>
              <input
                type="text"
                name={s}
                id={s}
                value={formData[s]}
                onChange={handleInputChange}
                placeholder={`Barcode ${i}`}
              />
            </div>
          );
        })}
      </td>
      <td>
        <input
          type="text"
          name="Price"
          id="Price"
          value={formData.Price}
          onChange={handleInputChange}
        />
      </td>
      <td>
        <input
          type="text"
          name="Volume"
          id="Volume"
          value={formData.Volume}
          onChange={handleInputChange}
        />
      </td>
      <td>
        <select
          name="ItemGroupID"
          id="ItemGroup"
          value={formData.ItemGroupID}
          onChange={handleInputChange}
        >
          <option value="">Artikelgrupp</option>
          {itemGroups.map((item) => (
            <option key={item.ID} value={item.ID}>
              {item.Name}
            </option>
          ))}
        </select>
      </td>
      <td>
        <select
          name="ItemSubGroupID"
          id="SubItemGroup"
          value={formData.ItemSubGroupID}
          onChange={handleInputChange}
        >
          <option value="">Undergrupp</option>
          {subItemGroups
            .filter((subItem) => subItem.ItemGroupID === formData.ItemGroupID)
            .map((subItem) => (
              <option key={subItem.ID} value={subItem.ID}>
                {subItem.Name}
              </option>
            ))}
        </select>
      </td>
    </>
  );

  const RenderInventoryView = () => {
    const handleAmountChange = (event) => {
      setFormData({
        ...formData,
        Amount: event.target.value,
      });
    };

    return (
      <>
        <td>
          <label>{formData.Name}</label>
        </td>
        <td>
          <label>{formData.Price}</label>
        </td>
        <td>
          <input
            type="number"
            name="Amount"
            id="Amount"
            value={formData.Amount}
            onChange={handleAmountChange}
            style={{ width: "50%" }} // Adjust the width as needed
          />
        </td>
        <td>
          <label>{(formData.Amount * formData.Price).toFixed(2)}</label>
        </td>
      </>
    );
  };

  function renderBarView() {
    return (
      <>
        <td>
          <input
            type="text"
            name="Name"
            id="Name"
            value={formData.Name}
            onChange={handleInputChange}
          />
        </td>
      </>
    );
  }

  function renderUserView() {
    return (
      <>
        <td>{object.name}</td>
        <td>{object.email}</td>
        <td>
          <select
            value={formData.Admin}
            onChange={handleInputChange}
            name="Admin"
          >
            <option value={1}>Ja</option>
            <option value={0}>Nej</option>
          </select>
        </td>
      </>
    );
  }

  const renderView = () => {
    switch (type) {
      case "Product":
        return renderProductView();
      case "InventoryData":
        return RenderInventoryView();
      case "Bar":
        return renderBarView();
      case "User":
        return renderUserView();
      default:
        return null; // or some default view
    }
  };

  if (!object) {
    return <div>Artikeln hittades inte</div>;
  }

  return (
    <>
      <tr className="EditView">{renderView()}</tr>
      <tr></tr>
      <tr className="EditView">
        <td colSpan="100%">
          <button name="Save" onClick={handleSave}>
            Spara
          </button>
          <button className="Delete" name="Delete" onClick={handleDelete}>
            Radera
          </button>
        </td>
      </tr>
    </>
  );
};
